import { logUsage } from 'owa-analytics';
import { mutatorAction } from 'satcheljs';
import getListViewStore from 'owa-mail-list-store/lib/store/Store';
import { getCopilotResultsTableViewId, dismissCopilotResultsTabMutator } from 'owa-mail-list-store';
import TableOperations from 'owa-mail-list-table-operations';
import type { CopilotResultsTableQuery } from 'owa-mail-list-store/lib/store/schema/CopilotResultsTableQuery';
import type TableView from 'owa-mail-list-store/lib/store/schema/TableView';

export type CopilotResultsDismissSource = 'ExplicitTabDismiss' | 'ExitSearch' | 'FolderSwitched';

const removeTableViewMutator = mutatorAction(
    'removeCopilotResultsTableView',
    (tableViews: Map<string, TableView>, tableViewId: string) => {
        tableViews.delete(tableViewId);
    }
);

/**
 * Fully cleans up the CopilotResults table:
 * 1. Clears all rows from the table view
 * 2. Removes the table view from the store
 * 3. Clears the copilot results tab tracking state
 */
export default function cleanupCopilotResultsTable(source: CopilotResultsDismissSource): void {
    const copilotResultsTableViewId = getCopilotResultsTableViewId();
    if (!copilotResultsTableViewId) {
        return;
    }

    const store = getListViewStore();
    const tableView = store.tableViews.get(copilotResultsTableViewId);

    if (tableView) {
        TableOperations.clear(tableView);
        removeTableViewMutator(store.tableViews, copilotResultsTableViewId);
        const { mailboxInfo } = tableView.tableQuery as CopilotResultsTableQuery;
        logUsage('CopilotResultsTabDismissed', mailboxInfo, { source });
    }

    dismissCopilotResultsTabMutator();
}
